import React, { useState } from 'react';
import { useRouter } from 'next/router';

import './CourseOverview.scss';
import { getString } from '../../helpers/styles';
import Transition from '../Transition/Transition.jsx';
import icons from '../../shared/assets/icons/redesign';
import { trackAction, usePlatform } from '../../helpers/tracking';
import CoursesBuyPopup from '../CoursesBuyPopup/CoursesBuyPopup.jsx';
import CoursesLoginPopup from '../CoursesLoginPopup/CoursesLoginPopup.jsx';

const { Check, Lock } = icons;

export default function CourseOverview({
  user,
  isInDepthCourse,
  hasAccess,
  config,
  data: {
    name,
    username,
    displayName,
    description,
    userImageUrl,
    courseChapters
  }
}) {
  const router = useRouter();
  const platform = usePlatform();

  const [buyPopup, showBuyPopup] = useState(false);
  const [loginPopup, showLoginPopup] = useState(false);

  return (
    <div className="courseOverview">
      <Transition on={loginPopup}>
        <CoursesLoginPopup config={config} showPopup={showLoginPopup} />
      </Transition>

      <Transition on={buyPopup && !isInDepthCourse}>
        <CoursesBuyPopup showPopup={showBuyPopup} />
      </Transition>

      {!isInDepthCourse && (
        <>
          <h1 className="courseOverview-name">{displayName}</h1>

          <p className="courseOverview-description">{description}</p>

          <img
            className="courseOverview-provider-logo"
            src={userImageUrl}
            alt="provider-logo"
          />
          <span className="courseOverview-provider-name">{username}</span>
        </>
      )}

      <ul className="courseOverview-chapter-list">
        {[...courseChapters]
          .sort((a, b) => (+a.prio >= +b.prio ? 1 : -1))
          .map((chapter) => (
            <li className="courseOverview-chapter-list-item" key={chapter.name}>
              <h3 className="courseOverview-chapter-name">
                {chapter.displayName}
              </h3>

              <ul className="courseOverview-module-list">
                {[...chapter.courseModules]
                  .sort((a, b) => (+a.prio >= +b.prio ? 1 : -1))
                  .map((module) => {
                    const isOpen = module.position === 'OPEN';

                    return (
                      <li
                        key={module.name}
                        className={getString([
                          {
                            value: 'courseOverview-module-list-item',
                            condition: true
                          },
                          {
                            value: 'courseOverview-module-list-item-watched',
                            condition: module.isWatched
                          }
                        ])}
                        onClick={() => {
                          trackAction(
                            platform,
                            'coursescoursepage',
                            'clickcoursemodule'
                          );

                          if (!isOpen) {
                            if (!user.username) return showLoginPopup(true);
                            if (!hasAccess) return showBuyPopup(true);
                          }

                          router.push(
                            `/zwangerschapscursus/${
                              isInDepthCourse ? 'ouder-en-kind/' : ''
                            }${encodeURIComponent(name)}/${encodeURIComponent(
                              module.name
                            )}`
                          );
                        }}
                      >
                        <div className="courseOverview-module-checkmark">
                          {module.isWatched && (
                            <Check className="courseOverview-module-checkmark-icon" />
                          )}
                        </div>
                        <div
                          className="courseOverview-module-list-item-name"
                          dangerouslySetInnerHTML={{
                            __html: module.displayName
                          }}
                        />

                        {!isOpen && !hasAccess && (
                          <Lock className="courseOverview-module-list-item-lock-icon" />
                        )}
                      </li>
                    );
                  })}
              </ul>
            </li>
          ))}
      </ul>
    </div>
  );
}
